import api from "@/service/api";

const state = () => ({
    config: null,
    scriptLoaded: false,
    scriptLoading: false,
    saving: false,
    error: null,
    acceptJsError: null,
    tokenData: null,
    throttle: null,
    recommendation: null,
})

const mutations = {
    setConfig(state, value) {
        state.config = value;
    },
    setScriptLoaded(state, value) {
        state.scriptLoaded = value;
    },
    setScriptLoading(state, value) {
        state.scriptLoading = value;
    },
    setSaving(state, value) {
        state.saving = value;
    },
    setError(state, value) {
        state.error = value;
    },
    setAcceptJsError(state, value) {
        state.acceptJsError = value;
    },
    setTokenData(state, value) {
        state.tokenData = value;
    },
    setThrottle(state, value) {
        state.throttle = value;
    },
    setRecommendation(state, value) {
        state.recommendation = value;
    },
}

const getErrorMessage = (error) => {
    if (
        error?.response?.data?.code === 'chargeFailed'
        && error?.response?.data?.message
    ) {
        return error.response.data.message;
    }

    if (
        error?.response?.data?.code === 'cardRestricted'
        && error?.response?.data?.message
    ) {
        return error.response.data.message;
    }

    return "There was an error processing your payment, please try again";
}

const actions = {
    loadConfig({ commit, state }) {
        if (state.config) {
            return Promise.resolve();
        }

        return api
            .get("/authorize/acceptJsConfig")
            .then((response) => {
                commit("setConfig", response.data);
            });
    },
    loadScript({ commit, state }) {
        if (state.scriptLoaded || state.scriptLoading) {
            return Promise.resolve();
        }

        if (!state.config) {
            return Promise.resolve();
        }

        if (document.querySelector('script[src*="AcceptUI"]')) {
            commit("setScriptLoaded", true);
            return Promise.resolve();
        }

        commit("setScriptLoading", true);

        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = state.config.acceptJsUrl;
            script.onload = () => {
                commit("setScriptLoaded", true);
                commit("setScriptLoading", false);
                resolve();
            };
            script.onerror = () => {
                commit("setScriptLoading", false);
                resolve();
            };
            document.head.appendChild(script);
        });
    },
    hostedTransaction({ commit }, payload) {
        commit("setError", null);
        commit("setRecommendation", null);
        commit("setSaving", true);

        api
            .post("/authorize/hostedTransaction", payload)
            .then(() => {
                commit("wallet/setPurchaseComplete", true, { root: true });
            })
            .catch((error) => {
                const code = error?.response?.data?.code;
                const recommendation = error?.response?.data?.recommendation;

                if (code === "recommendFintech" && recommendation) {
                    commit("setRecommendation", recommendation);
                    return;
                }

                if (error?.response?.data?.throttle) {
                    commit("setThrottle", error?.response?.data?.throttle);
                }

                commit("setError", getErrorMessage(error));
            })
            .then(() => {
                commit("setSaving", false);
            });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}
